import { motion } from 'framer-motion';
import { FiArrowUpRight, FiGithub } from 'react-icons/fi';
import SectionHeading from './SectionHeading';
import Icon from './Icon';

type GitHubSectionProps = {
  githubUrl: string;
  githubDisplayText: string;
};

function GitHubSection({ githubUrl, githubDisplayText }: GitHubSectionProps) {
  const hasGithubUrl = Boolean(githubUrl);

  return (
    <section id="github" className="section-shell">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <SectionHeading
          eyebrow="GitHub"
          title="Ready to surface open-source work and engineering samples."
          description="This section keeps the portfolio navigation complete and makes room for a public GitHub profile whenever it is available."
        />

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.5 }}
          className="glass-panel overflow-hidden rounded-[2rem] p-8"
        >
          <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-2xl">
              <div className="flex items-center gap-3 text-sky-200">
                <Icon icon={FiGithub} />
                <span className="text-sm font-semibold uppercase tracking-[0.3em]">
                  Developer Presence
                </span>
              </div>
              <h3 className="mt-5 text-2xl font-semibold text-white">
                Showcase repositories, architecture demos, and sample enterprise builds.
              </h3>
              <p className="mt-4 text-base leading-8 text-slate-300">
                {hasGithubUrl
                  ? 'The portfolio can link directly to a public GitHub profile for deeper technical validation.'
                  : 'A GitHub profile URL was not provided, so this section keeps the layout intact without inventing a link.'}
              </p>
            </div>

            {hasGithubUrl ? (
              <a href={githubUrl} target="_blank" rel="noreferrer" className="primary-button whitespace-nowrap">
                Visit GitHub
                <Icon icon={FiArrowUpRight} />
              </a>
            ) : (
              <div className="rounded-2xl border border-white/10 bg-white/5 px-5 py-4 text-sm leading-7 text-slate-200">
                {githubDisplayText}
              </div>
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default GitHubSection;
